import React from 'react';
import PropTypes from 'prop-types';
import login from '../../../../../client/app/screens/login/login.scss';
import { useGoogleLogin } from '@react-oauth/google';

function GoogleLoginButton(props) {
  const googleLogin = useGoogleLogin({
    onSuccess: codeResponse => props.handleGoogleResponse(codeResponse),
    flow: 'auth-code',
    scopes: 'openid email profile',
  });

  return (<button className={login.googleAuthBtn} onClick={() => googleLogin()}>
    <img
      className={login.googleAuthLogo}
      src="https://developers.google.com/identity/images/g-logo.png"
      alt="Google logo"
    />Sign in with Google</button>);
}

GoogleLoginButton.defaultProps = { handleGoogleResponse: () => {} };

GoogleLoginButton.propTypes = { handleGoogleResponse: PropTypes.func };

export default GoogleLoginButton;



// WEBPACK FOOTER //
// ./client/app/shared/components/Auth/googleLoginButton.jsx